import { SpeciesReference } from '@agria/theme-qab/src/types/global';

export const speciesReference: SpeciesReference = {
  'f4372701-68d2-4459-bdba-b3be753e80d4': {
    name: 'Dog',
    displayName: 'dog',
    litterName: 'Puppy',
    mixedBreedId: 'dd7430a3-f68b-4b5b-b321-6336f2c74c48',
  },
  'c2597178-071f-4940-825d-4d7351b5ffa4': {
    name: 'Cat',
    displayName: 'cat',
    litterName: 'Kitten',
    mixedBreedId: '140cef5c-8526-4831-9b41-cb83f53ecdcb',
  },
  '636b067c-dd3e-480d-87e7-d59df08c221c': {
    name: 'Equine',
    litterName: 'Foal',
    displayName: 'horse',
  },
};
